import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OrgContext } from "./PortalLayout";
import { getDashboard } from "../../services/portalService";

// Dashboard: the counts that need attention, the one big action, the
// organization and its sites.
const PortalHome = () => {
  const { org, user } = useContext(OrgContext);
  const first = (user?.name || "").split(" ")[0];
  const [d, setD] = useState({});
  useEffect(() => { getDashboard().then(setD).catch(() => {}); }, []);

  return (
    <>
      <h5 className="mb-3">{first ? `Namaste, ${first}` : "Welcome"}</h5>

      <Link to="/portal/requirements/new" className="portal-action">
        + Submit a plant or gardening requirement
      </Link>

      <div className="portal-tiles mb-3">
        <Link to="/portal/requirements" className="portal-tile"><div className="num">{d.openRequirements ?? "—"}</div><div className="lbl">Open requirements</div></Link>
        <Link to="/portal/quotations" className="portal-tile"><div className="num">{d.quotationsToApprove ?? "—"}</div><div className="lbl">Quotations to approve</div></Link>
        <Link to="/portal/orders" className="portal-tile"><div className="num">{d.ordersInProgress ?? "—"}</div><div className="lbl">Orders in progress</div></Link>
        <Link to="/portal/sites" className="portal-tile"><div className="num">{org?.sites?.length ?? "—"}</div><div className="lbl">Sites</div></Link>
      </div>

      <div className="portal-card">
        <h6>{org?.name || "Your organization"}</h6>
        {org?.billingAddress?.city && <div className="text-muted small">{[org.billingAddress.line1, org.billingAddress.city, org.billingAddress.state].filter(Boolean).join(", ")}</div>}
        {org?.sites?.length ? (
          <div className="portal-list mt-2">
            {org.sites.map((s) => (
              <div className="item" key={s.id}>
                <div className="fw-semibold">{s.name}</div>
                {s.contactName && <div className="small text-muted">{s.contactName} {s.contactPhone && `· +${s.contactPhone}`}</div>}
              </div>
            ))}
          </div>
        ) : (
          <div className="portal-empty">No sites yet. {user?.role === "CUST_ADMIN" ? <Link to="/portal/sites">Add one</Link> : "Ask your admin to add one."}</div>
        )}
      </div>
    </>
  );
};

export default PortalHome;
